module.exports = __webpack_public_path__ + "img/moveCenter.d4f193fb.png";